import React from "react";
import _ from "lodash";

const TeamsCard = ({ name, role, index, image }) => {
  return (
    <div className="relative text-center ">
      <div className="flex justify-center items-center">
        <img className="w-60 h-60 object-cover rounded-full" src={image} />
      </div>

      <div className="teamstext text-center py-2">
        <h2 className="text-lg font-semibold">{_.startCase(name)}</h2>
        <p className="text-md">{_.startCase(role)}</p>
      </div>
    </div>
  );
};

export default TeamsCard;
